<template>
    <div class="props-group layout">
      <el-form-item class="layout-type" label="布局类型" prop="name">
        <el-input readonly v-model="component.name"/>
      </el-form-item>
      <div v-show="showRatio" class="layout-ratio">
        <p>控件占比</p>
        <template v-if="component.name.includes('双列')">
          <div :class="['ratio-box', item.value === activeValue && 'active-box']" v-for="item in doubleLayoutType" :key="item.value" @click="selectRatioType(item.value)">{{item.label}}</div>
        </template>
        <template v-else-if="component.name.includes('三列')">
          <div :class="['ratio-box', item.value === activeValue && 'active-box']" v-for="item in tripleLayoutType" :key="item.value" @click="selectRatioType(item.value)">{{item.label}}</div>
        </template>
      </div>
    </div>
</template>

<script>
export default {
  name: 'attr-name',
  props: ['component'],
  data () {
    return {
      layoutType: '',
      doubleLayoutType: [
        {value: '1:1', label: '1:1'},
        {value: '1:3', label: '1:3'},
        {value: '3:1', label: '3:1'}
      ],
      tripleLayoutType: [
        {value: '1:1:1', label: '1:1:1'},
        {value: '1:2:1', label: '1:2:1'},
        {value: '1:1:2', label: '1:1:2'},
        {value: '2:1:1', label: '2:1:1'}
      ]
    }
  },
  computed: {
    showRatio () {
      return this.component.name.includes('双列') || this.component.name.includes('三列')
    },
    activeValue () {
      if (!this.component.properties.layoutRatioType) {
        if (this.component.name.includes('双列')) {
          return '1:1'
        } else if (this.component.name.includes('三列')) {
          return '1:1:1'
        }
      } else {
        return this.component.properties.layoutRatioType
      }
    }
  },
  methods: {
    selectRatioType (val) {
      if (val) {
        this.component.properties.layoutRatioType = val
      }
    }
  }
}
</script>

<style lang="scss">
  .props-group.layout{
    .layout-type{
      padding-bottom: 14px;
      margin-bottom: 0;
      border-bottom: 1px solid #EBEBEB;
    }
    .layout-ratio{
      p{
        font-size: 12px;
        color: #606266;
      }
      .ratio-box{
        display: inline-block;
        text-align: center;
        width: 42px;
        height: 18px;
        line-height: 18px;
        margin-top: 14px;
        margin-right: 10px;
        border: 1px solid #EBEBEB;
        border-radius: 4px;
        cursor: pointer;
      }
      .ratio-box.active-box{
        color: #54ABF1;
        border-color: #54ABF1;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/layout.vue